module.exports = __webpack_public_path__ + "img/ppr-equipments-buttons-add.400cae9a.svg";